<template>
  <div
    class="empty-teacher-card rounded-5 d-flex justify-content-between align-items-center nowrap"
    :class="show_border ? 'border_brand_white' : null"
  >
    <div
      class="left w-100 d-flex justify-content-start align-items-center nowrap"
    >
      <!-- AVATAR -->
      <div
        class="avatar avatar-square avatar_sm_md overflow-hidden"
        :class="show_loader ? 'skeleton-loader' : 'border_grey_light_bg'"
      ></div>

      <!-- TEACHER INFO -->
      <div class="teacher-info w-100">
        <div
          class="name overflow-hidden"
          :class="show_loader ? 'skeleton-loader' : 'border_grey_light_bg'"
        ></div>
        <div
          class="meta overflow-hidden"
          :class="show_loader ? 'skeleton-loader' : 'border_grey_light_bg'"
        ></div>
      </div>
    </div>

    <!-- OPTION -->
    <div
      class="option overflow-hidden"
      :class="show_loader ? 'skeleton-loader' : 'border_grey_light_bg'"
    ></div>
  </div>
</template>

<script>
export default {
  name: "TeacherDefaultCard",

  props: {
    show_loader: {
      type: Boolean,
      default: true,
    },
    show_border: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.empty-teacher-card {
  background: rgba(#ffffff, 0.6);
  padding: 14px 15px;
  margin-bottom: 2px;
  @include flex_row_between_nowrap;

  @include breakpoint_max(xs) {
    width: 100%;
  }

  .avatar {
    margin-right: 15px;
  }

  .name {
    width: 188px;
    height: 18px;
    margin-bottom: 7px;

    @include breakpoint_max(xs) {
      width: 95%;
    }
  }

  .meta {
    width: 145px;
    height: 10px;

    @include breakpoint_max(xs) {
      width: 75%;
    }
  }

  .option {
    width: 82px;
    height: 25px;

    @include breakpoint_max(xs) {
      display: none;
    }
  }
}
</style>
